import bannerStore from 'background';
import history from 'browser-history';
import legacyRoutes from 'legacy-routes';
import {observer, Provider} from 'mobx-react';
import React from 'react';
import {Route, Router, Switch} from 'react-router-dom';
import {currentUser} from 'stores/currentUser';
import Rex from 'components/rex/Rex';
import {Provider as ReduxProvider} from 'react-redux';
import store from 'stores/rootStore';

const ElisaViihde = () => (
  <Provider bannerStore={bannerStore} currentUser={currentUser}>
    <Router history={history}>
      <div>
        {legacyRoutes}
        {/* Add new React page routes below */}
        <ReduxProvider store={store}>
          <Switch>
            <Route path='/jatko' component={Rex} key='rex' />
          </Switch>
        </ReduxProvider>
      </div>
    </Router>
  </Provider>
);

export default observer(ElisaViihde);



// WEBPACK FOOTER //
// ./web/js/components/ElisaViihde.js